import { Address } from 'viem';

export const mUsdTokenAddress: Address = '0xdD468A1DDc392dcdbEf6db6e34E89AA338F9F186';
